module.exports = __webpack_public_path__ + "bc7714b4379fd9ffeff9d2173d271dec.png";